import { styled } from '@mui/material';

import { useAppContext } from '@app-velocity/config';

import { useI18n } from '@app-velocity/i18n';

import { SettingsOutlineIcon } from '@app-velocity/icons';

import { PrototypeVerdict } from '@app-velocity/ui';

import { useSimulationWidgetContext } from '../../hooks/useSimulationWidgetContext';
import { useSingleSimulationMetrics } from '../../hooks/useSingleSimulationMetrics';
import { SingleMetric } from '../SingleMetric';

const Wrapper = styled('div')(({ theme }) => ({
  background: '#fff',
  borderRadius: theme.spacing(2),
  padding: `${theme.spacing(6)} ${theme.spacing(2)}`,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

const MetricsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'space-around',
  gap: theme.spacing(4),
  flexWrap: 'wrap',
}));

const StyledTitle = styled('span')<{ success: boolean }>(({ success }) => ({
  fontWeight: 700,
  color: success
    ? 'var(--success-success-text-primary-color)'
    : 'var(--error-error-text-primary-color)',
}));

const RequirementsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
}));

const MetricsTitle = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  justifyContent: 'center',
  fontSize: 16,
  color: 'var(--text-heading-color)',
  fontWeight: 600,
}));

const SettingsButton = styled('div')({
  display: 'flex',
  cursor: 'pointer',
  border: 'none',
  background: 'transparent',
  svg: {
    fill: '#969696',
  },
});

export const Requirements = () => {
  const { t } = useI18n();
  const { AVMLink } = useAppContext();
  const { statistics, config, shareToken } = useSimulationWidgetContext();

  const goToSettings = () => {
    window.open(
      `${AVMLink}/report/${shareToken}/overview?action=target-metrics`
    );
  };

  const { metrics } = useSingleSimulationMetrics(statistics, config);
  if (!metrics || metrics.length === 0) return null;

  return (
    <RequirementsContainer>
      <StyledTitle success={!!statistics?.meetsRequirements}>
        {t('prototypes:report.decision.title')}
      </StyledTitle>
      <PrototypeVerdict
        success={!!statistics?.meetsRequirements}
        variant="plugin"
      />
      <Wrapper>
        <MetricsTitle>
          {t('prototypes:report.settings.target_metrics')}
          <SettingsButton onClick={goToSettings}>
            <SettingsOutlineIcon />
          </SettingsButton>
        </MetricsTitle>

        <MetricsContainer>
          {metrics.map((metric, index) => (
            <SingleMetric showTarget key={index} {...metric} />
          ))}
        </MetricsContainer>
      </Wrapper>
    </RequirementsContainer>
  );
};
